import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  loading: "_275ln5b77"
});
const wrapper = "_275w1u6qgnz";
const text = "_275t85svf6";
const filtersWrapper = "_275fylvu4t";
const filter = "_275fpkg9j0";
makeSelectors({
  filtersWrapper
});

export { filter, filtersWrapper, modifiers, text, wrapper };
import "./filters.style.linaria.module.css";
//# sourceMappingURL=filters.style.js.map
